import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-lg font-heading font-semibold tracking-wide text-foreground-900 cursor-pointer">
              itaobuy spread.pics
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              Il principale hub italiano dedicato a Itaobuy Spreadsheet. Scopri prodotti cinesi di qualità con guide dettagliate e link diretti.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">Guide</h3>
            <div className="flex flex-col gap-2.5">
              <Link to="/articoli/guida-completa-itaobuy-spreadsheet" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Guida Completa</Link>
              <Link to="/author" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Chi Siamo</Link>
              <Link to="/about-itaobuy-spreadsheet" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">La Nostra Missione</Link>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">Categorie</h3>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Scarpe</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Felpe</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">T-Shirt</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Giacche</a>
              <Link to="/" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer transition-colors">Tutte le categorie →</Link>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">Trust</h3>
            <div className="flex flex-col gap-2.5">
              <Link to="/privacy-policy" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Privacy Policy</Link>
              <Link to="/cookie-policy" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Cookie Policy</Link>
              <Link to="/disclaimer" className="text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors">Disclaimer</Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer transition-colors font-medium">
                Vai a Kaspreadsheet →
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} itaobuyspread.pics — Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-3">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-secondary-300 transition-colors cursor-pointer">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-secondary-300 transition-colors cursor-pointer">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}